import React, { useEffect, useState } from "react";
import axios from "axios";
import { ReactSession } from "react-client-session";
import "./BaaHam_ContentproductionUser_Profile.css";

function BaaHam_ContentproductionUser_Profile() {
    ReactSession.setStoreType("localStorage");
    const UserId = ReactSession.get("UserId");

    const [value, setValue] = useState("");
    const [userData, setUserData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: null,
        password: "",
        isDeleted: false,
        type: "producerUser",
        active: true,
        createdAt: "",
        updatedAt: "",
        id: "",
    });

    useEffect(() => {
        if (UserId) {
            axios
                .get("https://hammaskan.ir:8443/api/users/" + UserId, {
                    params: {},
                })
                .then((res) => {
                    // console.log(res.data.data);
                    setUserData(res.data.data);
                })
                .catch((error) => {
                    // console.log(error);
                    window.location.href = "./Account";
                });
        } else {
            window.location.href = "./Account";
        }
    }, []);

    const updateUserData = () => {
        var labelLSGNDialogWait = document.getElementById("labelLSGNDialogWait");
        var loginDialogOk = document.getElementById("labelLSGNDialogOk");
        var loginDialogErr = document.getElementById("labelLSGNDialogErr");

        labelLSGNDialogWait.style.display = "inline-block";
        loginDialogOk.style.display = "none";
        loginDialogErr.style.display = "none";

        console.log("ok");
        if (document.getElementById("userFirstname") && document.getElementById("userLastname") && document.getElementById("userPhoneNumber")) {
            var userFirstname = document.getElementById("userFirstname").value;
            var userLastname = document.getElementById("userLastname").value;
            // var userPhoneNumber = document.getElementById("userPhoneNumber").value;
            var userEmail = document.getElementById("userEmail").value;
            var userAddress = document.getElementById("userAddress").value;
            var params = {
                firstName: userFirstname,
                lastName: userLastname,
                // phoneNumber: userPhoneNumber,
                email: userEmail,
                address: userAddress,
            };

            if (params) {
                axios
                    .put("https://hammaskan.ir:8443/api/users/" + UserId, params)
                    .then((res) => {
                        labelLSGNDialogWait.style.display = "none";
                        loginDialogOk.style.display = "inline-block";
                        loginDialogErr.style.display = "none";
                        console.log(res);
                    })
                    .catch((error) => {
                        console.log(error);
                        labelLSGNDialogWait.style.display = "none";
                        loginDialogOk.style.display = "none";
                        loginDialogErr.style.display = "inline-block";
                        if (error.response.data.message) {
                            loginDialogErr.textContent = error.response.data.message;
                        } else {
                            loginDialogErr.textContent = "مشکلی در بروز رسانی اطلاعات کاربران وجود دارد لطفا با پشتیبانی تماس بگیرید";
                        }
                    });
            } else {
                // loginDialogErr.style.display = "inline-block";
                // loginDialogErr.textContent = " کد ورود خود را وارد نمایید";
            }
        }
    };

    return (
        <div className="BaaHam_ContentproductionUser_Profile">
            <div className="BaaHam_NU_ProfileInputsContainer">
                <div className="BaaHam_NU_ProfileInputContainer">
                    <span className="BaaHam_NU_ProfileInputTitle">
                        نام <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="InputExactContainerForBack">
                        <input className="BaaHam_NU_ProfileInput" id="userFirstname" type="text" defaultValue={userData.firstName} />
                    </div>
                </div>
                <div className="BaaHam_NU_ProfileInputContainer">
                    <span className="BaaHam_NU_ProfileInputTitle">
                        نام خانوادگی <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="InputExactContainerForBack">
                        <input className="BaaHam_NU_ProfileInput" id="userLastname" type="text" defaultValue={userData.lastName} />
                    </div>
                </div>
                <div className="BaaHam_NU_ProfileInputContainer">
                    <span className="BaaHam_NU_ProfileInputTitle">
                        شماره تلفن <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="InputExactContainerForBack">
                        <input className="BaaHam_NU_ProfileInput" id="userPhoneNumber" type="text" defaultValue={userData.phoneNumber} disabled />
                    </div>
                </div>
                <div className="BaaHam_NU_ProfileInputContainer">
                    <span className="BaaHam_NU_ProfileInputTitle">
                        ایمیل <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="InputExactContainerForBack">
                        <input className="BaaHam_NU_ProfileInput" id="userEmail" type="text" defaultValue={userData.email} />
                    </div>
                </div>
            </div>
            <div className="BaaHam_NU_ProfileTextAreaContainer">
                <span className="BaaHam_NU_ProfileInputTitle">
                    آدرس <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                </span>
                <div className="InputExactContainerForBackTextArea">
                    <textarea className="BaaHam_NU_ProfileTextArea" id="userAddress" defaultValue={userData.address} />
                </div>
            </div>
            <div className="labelLSGN" id="labelLSGNDialogWait" style={{ display: "none", fontSize: "14px", backgroundColor: "#1B9CFC", color: "snow", width: "85%", padding: "12px 8px", borderRadius: "6px" }}>
                لطفا کمی صبر کنید ...
            </div>
            <div className="labelLSGN" id="labelLSGNDialogOk" style={{ display: "none", fontSize: "14px", backgroundColor: "#06d6a0", color: "snow", width: "96%", padding: "12px 8px", borderRadius: "6px", margin: "12px 0" }}>
                اطلاعات شما با موفقیت به روزرسانی شد
            </div>
            <div className="labelLSGN" id="labelLSGNDialogErr" style={{ display: "none", fontSize: "14px", backgroundColor: "tomato", color: "snow", width: "96%", padding: "12px 8px", borderRadius: "6px", margin: "12px 0" }}>
                --
            </div>
            <div className="BaaHam_NU_ProfileButtonContainer">
                <div className="BaaHam_NU_ProfileButton" onClick={updateUserData}>
                    <span>به روزرسانی</span>
                </div>
            </div>
        </div>
    );
}

export default BaaHam_ContentproductionUser_Profile;
